module.exports = __webpack_public_path__ + "static/media/a2.4d28cd88.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/a2.png
// module id = 44
// module chunks = 0